import React from 'react';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, info) {
        console.error('ErrorBoundary caught:', error, info);
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className="d-flex flex-column align-items-center justify-content-center min-vh-100 bg-dark text-white p-4">
                    <div className="text-center" style={{ maxWidth: '500px' }}>
                        <div style={{ fontSize: '4rem' }}>💥</div>
                        <h2 className="mt-3 mb-2">Etwas ist schiefgelaufen</h2>
                        <p className="text-secondary mb-4">
                            Ein unerwarteter Fehler ist aufgetreten. Bitte lade die Seite neu oder gehe zurück.
                        </p>
                        {process.env.NODE_ENV === 'development' && this.state.error && (
                            <pre className="text-danger text-start small bg-secondary p-3 rounded mb-4" style={{ overflow: 'auto' }}>
                                {this.state.error.toString()}
                            </pre>
                        )}
                        <div className="d-flex gap-3 justify-content-center">
                            <button
                                className="btn btn-warning"
                                onClick={() => window.location.reload()}
                            >
                                Seite neu laden
                            </button>
                            <button
                                className="btn btn-outline-light"
                                onClick={() => { this.setState({ hasError: false, error: null }); window.location.href = '/dashboard'; }}
                            >
                                Zum Dashboard
                            </button>
                        </div>
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
